import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z=".default-unhandled-error{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:48px 48px 48px 32px}@media only screen and (max-width:767px){.default-unhandled-error{padding:32px 16px}}.error-reset-action{padding:var(--swan-comp-button-space-inner-vertical)!important;position:absolute;right:var(--swan-sem-space-4);top:var(--swan-sem-space-4)}";styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=styles.scss.js.map
